import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getNextValues } from 'src/components/filters';
import { IFilterState } from '../../../types';
import { fetchFilterFields } from './filter-slice-async-thunk';

const initialState: IFilterState = {
  globalFilterCombinations: [],
  globalFilterFormFields: [],
  globalFilterInitialValues: {},
  globalFilterValue: {},
  isFetchingFilterFields: false
};

const filterSlice = createSlice({
  name: 'filter-slice-2',
  initialState,
  reducers: {
    setGlobalFilterValues(
      state,
      action: PayloadAction<ReturnType<typeof getNextValues>['newFormValues']>
    ) {
      state.globalFilterValue = action.payload;
    },
    setGlobalFilterFieldOptions(
      state,
      action: PayloadAction<
        ReturnType<typeof getNextValues>['fieldNameToOptionsMap']
      >
    ) {
      const fieldNameToOptionsMap = action.payload;
      state.globalFilterFormFields = state.globalFilterFormFields.map(
        (filter) => {
          if (fieldNameToOptionsMap[filter.name]) {
            return { ...filter, values: fieldNameToOptionsMap[filter.name] };
          }
          return filter;
        }
      );
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(fetchFilterFields.rejected, (state) => {
        state.isFetchingFilterFields = false;
        state.globalFilterFormFields = [];
        state.globalFilterInitialValues = {};
        state.globalFilterValue = {};
        state.globalFilterCombinations = [];
      })
      .addCase(fetchFilterFields.pending, (state) => {
        state.isFetchingFilterFields = true;
        state.globalFilterFormFields = [];
        state.globalFilterInitialValues = {};
        state.globalFilterValue = {};
        state.globalFilterCombinations = [];
      })
      .addCase(fetchFilterFields.fulfilled, (state, action) => {
        state.isFetchingFilterFields = false;
        const { combinations, formFieldsWithUpdatedOptions, newFormValues } =
          action.payload;
        state.globalFilterFormFields = formFieldsWithUpdatedOptions;
        state.globalFilterInitialValues = newFormValues;
        state.globalFilterValue = newFormValues;
        state.globalFilterCombinations = combinations;
      })
});

export const { setGlobalFilterFieldOptions, setGlobalFilterValues } =
  filterSlice.actions;

export default filterSlice;
